import Spinner from 'react-bootstrap/Spinner';
export default function Loader() {
    return(
        <div className='ms-3'>
            <Spinner animation='border' variant='primary' />
        </div>
        
    )
}